import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_icon_plus = _resolveComponent("icon-plus")!
  const _component_icon_minus = _resolveComponent("icon-minus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Numero di rate",
          text: "Numero di rate"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localValue.number) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.number]
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Importo di ogni rata",
          text: "Importo di ogni rata"
        })
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.amount) = $event))
      }, null, 512), [
        [_vModelText, _ctx.localValue.amount]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Genera un voucher su questi numeri rata",
          text: "Genera un voucher su questi numeri rata"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
        }, [
          _createVNode(_component_icon_plus)
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.createVacationVoucherOnNumbers, (item, i) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            class: "form-control",
            "onUpdate:modelValue": ($event: any) => ((_ctx.localValue.createVacationVoucherOnNumbers[i]) = $event)
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.localValue.createVacationVoucherOnNumbers[i]]
          ]),
          _createElementVNode("button", {
            class: "btn btn-danger",
            onClick: ($event: any) => (_ctx.remove(i))
          }, [
            _createVNode(_component_icon_minus)
          ], 8, _hoisted_7)
        ]))
      }), 256))
    ])
  ], 64))
}